"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUS_BUTTON_TEST_ID = exports.MINUS_BUTTON_TEST_ID = exports.COUNTER_TEST_ID = void 0;
var COUNTER_TEST_ID = exports.COUNTER_TEST_ID = 'COUNTER_TEST_ID';
var PLUS_BUTTON_TEST_ID = exports.PLUS_BUTTON_TEST_ID = 'PLUS_BUTTON_TEST_ID';
var MINUS_BUTTON_TEST_ID = exports.MINUS_BUTTON_TEST_ID = 'MINUS_BUTTON_TEST_ID';